import { Presenter } from 'src/app/core/architecture/presenter';
import { ServiceBookItemListResponse } from '../output-data/service-book-item-list.response';

export abstract class ServiceBookItemsPresenter<T>
                extends Presenter<T> {
   public abstract showList(response: ServiceBookItemListResponse): void;
}
